import { getGoalsAndInterventionsByOrderOptions } from '@generated';
import { useOrderItems } from '~/features/orders/queries';

export function useGoalsAndnterventionsForOrder(orderId: string) {
	return useOrderItems(orderId, getGoalsAndInterventionsByOrderOptions, (fullOrder, result) => {
		fullOrder.goals = result.goals;
		fullOrder.interventions = result.interventions;
	});
}
